import React, { useState } from "react";

import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { ListItemIcon } from "@material-ui/core";
import PropTypes from "prop-types";
import SidebarItem from "./SidebarItem";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { drawerWidth } from "../../../styleVariables";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import withWidth from "@material-ui/core/withWidth";
import Typography from "@material-ui/core/Typography";
import { VerifiedFooter } from "../../../components/icons";
import Divider from "@material-ui/core/Divider";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {
  logoutUser,
  resetPayment,
} from "../../../store/actions/authActionCreators";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  trackDwebEvent,
  loginDwebEvent,
  logoutDwebEvent,
} from "../../analytics";
import CallIcon from "@material-ui/icons/Call";

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: "relative",
    width: drawerWidth,
    maxWidth: drawerWidth,
    height: "calc(100vh - 200px)",
    zIndex: theme.zIndex.drawer + 99,
  },
  modal: {
    [theme.breakpoints.down("sm")]: {
      top: "56px!important",
    },
    [theme.breakpoints.up("sm")]: {
      top: "64px!important",
    },
    zIndex: "1000!important",
  },
  backdrop: {
    [theme.breakpoints.down("sm")]: {
      top: "56px",
    },
    [theme.breakpoints.up("sm")]: {
      top: "64px",
    },
  },
  menuList: {
    padding: "24px 8px",
    "& a": {
      fontSize: 14,
    },
  },
  menuListUser: {
    padding: "24px 8px",
    paddingBottom: "0px !important",
    "& a": {
      fontSize: 14,
    },
  },
  verifiedDiv: {
    textAlign: "center",
    alignItems: "center",
    position: "fixed",
    bottom: 0,
    paddingBottom: 40,
    paddingTop: 20,
    maxWidth: 269,
    width: "100%",
    backgroundColor: "#fff",
    //borderTop:'1px solid #f1f1f1'
  },
  listItemLogout: {
    padding: "0px",
  },
  divLogoutInner: {
    display: "flex",
    marginLeft: 8,
    marginRight: 8,
    border: "1px solid white",
    borderRadius: "8px",
    padding: 12,
    paddingLeft: 16,
    alignItems: "center",
  },
  divHelpLine: {
    display: "flex",
    marginLeft: 8,
    marginRight: 8,
    border: "1px solid white",
    borderRadius: "8px",
    padding: 12,
    paddingLeft: 16,
    alignItems: "center",
  },
  divLogout: {
    fontSize: 16,
    marginLeft: 16,
    fontWeight: "bold",
  },
  menuItem: {
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: 14,
    fontWeight: 500,
    paddingTop: 22,
    paddingBottom: 22,
    '& .MuiTypography-root': {
      fontWeight: 300
    }
  },
  menuLink: {
    position: 'relative',
    display: 'block',
    color: 'inherit',
    textDecoration: 'none',
    "&:hover": {
      textDecoration: 'none'
    },
  },
  menuIcon: {
    marginLeft: theme.spacing(1) * 2,
    marginRight: theme.spacing(1) * 2
  }
}));

const Sidebar = ({
  opened,
  toggleDrawer,
  routes,
  location,
  subscriptionStatus,
  user,
  dispatchPaymentReset,
  dispatchLogoutAction,
}) => {
  const classes = useStyles();
  const [activeRoute, setActiveRoute] = useState(undefined);
  const toggleMenu = (index) =>
    setActiveRoute(activeRoute === index ? undefined : index);

  const menu = (
    <List
      component="div"
      className={
        user &&
        user.userInfo &&
        user.userInfo.role &&
        user.userInfo.role === "USER"
          ? classes.menuListUser
          : classes.menuList
      }
    >
      {routes.map((route, index) => {
        let isCurrentPath =
          location && location.pathname.indexOf(route.path) > -1 ? true : false;
        return (
          <SidebarItem
            key={index}
            index={index}
            route={route}
            subscriptionStatus={subscriptionStatus}
            activeRoute={activeRoute}
            toggleMenu={toggleMenu}
            currentPath={isCurrentPath}
          />
        );
      })}
      {/* <a href="tel:08046802342" className={classes.menuLink}>
        <ListItem button className={classes.menuItem}>
        <ListItemIcon>
        <CallIcon style={{ color: "#0c8f64" }} className={classes.menuIcon} />
        </ListItemIcon>
        <Typography variant="body1" className={"flexSpacer"}>
          Helpline-080 4680 2342
        </Typography>
        </ListItem>
      </a> */}
    </List>
  );

  const handleLogOut = () => {
    logoutDwebEvent(user && user.userInfo ? user.userInfo : {});
    dispatchPaymentReset();
    dispatchLogoutAction();
  };

  return (
    <>
      <Hidden only={["xs", "sm"]}>
        <Drawer
          variant="persistent"
          classes={{
            paper: classes.drawerPaper,
          }}
          open={opened}
          ModalProps={{
            keepMounted: false,
            className: classes.modal,
            BackdropProps: {
              className: classes.backdrop,
            },
            onBackdropClick: toggleDrawer,
          }}
        >
          <div>
            {menu}

            {user &&
              user.userInfo &&
              user.userInfo.role &&
              user.userInfo.role === "USER" && (
                <List
                  className={classes.marginTopV1}
                  onClick={() => handleLogOut()}
                >
                  <ListItem button className={classes.listItemLogout}>
                    <div className={classes.divLogoutInner}>
                      <ExitToAppIcon />
                      <div className={classes.divLogout}>Logout</div>
                    </div>
                  </ListItem>
                </List>
              )}
          </div>
          <div className={classes.verifiedDiv}>
            <div className={classes.footerImgDiv}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/footer.svg`}
                alt={"Transport Footer"}
              />
            </div>
          </div>
        </Drawer>
      </Hidden>
    </>
  );
};

Sidebar.prototypes = {
  opened: PropTypes.func,
  toggleDrawer: PropTypes.func,
  closeDrawer: PropTypes.func,
  openDrawer: PropTypes.func,
  routes: PropTypes.object,
};

const SidebarWithRouter = withRouter(Sidebar);

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => ({
  dispatchPaymentReset: () => dispatch(resetPayment()),
  dispatchLogoutAction: () => dispatch(logoutUser()),
});

const enhance = compose(
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
);
export default enhance(SidebarWithRouter);

// export default withWidth()(SidebarWithRouter);
